import { Component } from '@angular/core';
import { TournamentOverviewComponent } from 'src/app/components/tournaments/tournament-overview/tournament-overview.component';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { TournamentDetailsService } from 'src/app/services/tournaments/tournament-details.service';
import { LicenceService } from 'src/app/services/utils/licence.service';

@Component({
  selector: 'app-leader-board',
  templateUrl: './leader-board.component.html',
  styleUrls: ['./leader-board.component.scss']
})
export class LeaderBoardComponent extends TournamentOverviewComponent {

  constructor(
    protected tournamentDetailsService: TournamentDetailsService,
    protected loginStatusService: LoginStatusService,
    protected licenceService: LicenceService
  ) {
    super(
      tournamentDetailsService,
      loginStatusService,
      licenceService
    )
  }
  isShowMore: boolean = false;
  INITIAL_RANK_LENGTH: number = 20;
  SHOWMORE_RANK_LENGTH: number = 200;
  rankSize = this.INITIAL_RANK_LENGTH;

  ngOnInit(): void {
    this.getDetails();
  }

}
